<template>
  <div>
    <h2 class="text-xl mb-3">Categories</h2>
    <div class="flex flex-col">
      <router-link class="link mb-2" :to="{ name: 'education' }">Education</router-link>
      <router-link class="link mb-2" :to="{ name: 'design' }">Design</router-link>
      <router-link class="link mb-2" :to="{ name: 'merch' }">Merch</router-link>
      <router-link class="link mb-2" :to="{ name: 'team' }">Team</router-link>
      <router-link class="link mb-2" :to="{ name: 'partners' }">Partners</router-link>
      <router-link class="link mb-2" :to="{ name: 'news' }">News</router-link>
      <router-link class="link mb-2" :to="{ name: 'resources' }">Resources</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
};
</script>

<style scoped></style>
